import { useEffect, useRef, useState } from "react";
import useMediaQuery from "../../../hooks/useMediaQuery";
import { connect } from 'react-redux';
import { get_categorias } from "../../../redux/actions/categorias";
import { LuPlus, LuMinus } from "react-icons/lu";
import styles from './CategoryList.module.css';
import close from '../../../styles/shared/CloseButton.module.css';

const CategoryList = ({ get_categorias, categorias, mostrarPorCategoria, mostrarPorEquipo }) => {
    useEffect(() => {
        get_categorias();
    }, [get_categorias]);

    const categoryRef = useRef(null);
    const [showSecciones, setShowSecciones] = useState(false);
    const [currentCategory, setCurrentCategory] = useState(null);
    const [selectedSeccion, setSelectedSeccion] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleClickOutside = (event) => {
        if (categoryRef.current && !categoryRef.current.contains(event.target)) {
            setShowSecciones(false);
            setCurrentCategory(null);
            setSelectedSeccion(null);
            setIsMobileMenuOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleCategoryClick = (categoria) => {
        if (categoria === "Todo") {
            setCurrentCategory(null);
            setSelectedSeccion(null);
            setShowSecciones(false);
            mostrarPorCategoria("Todo");
            setIsMobileMenuOpen(false); 
        } else {
            if (categoria.secciones && categoria.secciones.length > 0) {
                setCurrentCategory(categoria);
                setShowSecciones(true);
                setSelectedSeccion(null);
                mostrarPorCategoria(categoria.nombre);
            } else {
                setCurrentCategory(categoria);
                setShowSecciones(false);
                setSelectedSeccion(null);
                mostrarPorCategoria(categoria.nombre);
                setIsMobileMenuOpen(false);
            }
        }
    };

    const handleSeccionClick = (seccion, event) => {
        event.stopPropagation();
        setSelectedSeccion(seccion);
        mostrarPorCategoria(currentCategory.nombre, seccion.nombre);
        setIsMobileMenuOpen(false); 
    };

    const isMobile = useMediaQuery('(max-width: 1270px)');

    return (
        <>
            {isMobile && (
                <button
                    className={styles.toggle}
                    aria-label={isMobileMenuOpen ? 'Cerrar menú de categorías' : 'Abrir menú de categorías'}
                    onClick={() => setIsMobileMenuOpen((open) => !open)}
                >
                    {isMobileMenuOpen ? <LuMinus /> : <LuPlus />}
                </button>
            )}
            <div
                ref={categoryRef}
                className={`${styles.categorias}${isMobile && isMobileMenuOpen ? ' open' : ''}`}
                style={isMobile && !isMobileMenuOpen ? { pointerEvents: 'none', visibility: 'hidden' } : {}}
            >
                <div className={styles.table}>
                    <table>
                        <thead className={styles.thead}>
                            <tr>
                                <th className={styles.title}>
                                    <span className={styles.titleText} data-text="Categorías">Categorías</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className={styles.item} onClick={() => handleCategoryClick("Todo")}> 
                                <td>{"Todo"} {(!currentCategory && !showSecciones) ? <LuMinus /> : <LuPlus />}</td>
                            </tr>
                            {categorias && categorias.map(categoria => (
                                <tr className={styles.item} key={categoria.id} onClick={() => handleCategoryClick(categoria)}>
                                    <td>{categoria.nombre} {currentCategory && currentCategory.id === categoria.id  ? <LuMinus /> : <LuPlus />}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {showSecciones && currentCategory && currentCategory.secciones && (
                    isMobile ? (
                        <div style={{ width: '100vw', maxWidth: '100vw', background: '#fff', borderRadius: 0, margin: 0, padding: 0 }}>
                            <div className="sub_categorias__header">
                                <h2
                                    className={`${styles.subTitle} ${!selectedSeccion ? styles.selected : ''}`}
                                    onClick={() => {
                                        setSelectedSeccion(null);
                                        mostrarPorCategoria(currentCategory.nombre);
                                    }}
                                >
                                    {currentCategory.nombre}
                                </h2>
                                <button
                                    className={close.closeButton}
                                    onClick={() => setShowSecciones(false)}
                                >
                                    &times;
                                </button>
                            </div>
                            <ul className={styles.subList}>
                                {currentCategory.secciones && currentCategory.secciones.map(seccion => (
                                    <li
                                        key={seccion.id}
                                        className={`${styles.subItem} ${selectedSeccion && selectedSeccion.id === seccion.id ? styles.selected : ''}`}
                                        onClick={(event) => handleSeccionClick(seccion, event)}
                                    >
                                        {seccion.nombre}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <div className={styles.subTable}>
                            <div className="sub_categorias__header">
                                <h2
                                    className={`${styles.subTitle} ${!selectedSeccion ? styles.selected : ''}`}
                                    onClick={() => {
                                        setSelectedSeccion(null);
                                        mostrarPorCategoria(currentCategory.nombre);
                                    }}
                                >
                                    {currentCategory.nombre}
                                </h2>
                                <button
                                    className={close.closeButton}
                                    onClick={() => setShowSecciones(false)}
                                >
                                    &times;
                                </button>
                            </div>
                            <ul className={styles.subList}>
                                {currentCategory.secciones && currentCategory.secciones.map(seccion => (
                                    <li
                                        key={seccion.id}
                                        className={`${styles.subItem} ${selectedSeccion && selectedSeccion.id === seccion.id ? styles.selected : ''}`}
                                        onClick={(event) => handleSeccionClick(seccion, event)}
                                    >
                                        {seccion.nombre}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )
                )}
            </div>
        </>
    );
};

const mapStateToProps = state => ({
    categorias: state.Categorias.categorias,
});

export default connect(mapStateToProps, {
    get_categorias,
})(CategoryList);